import type { ReactNode } from 'react';
import { Button } from '@carbon/react';
import { ArrowLeft } from '@carbon/react/icons';
import style from './type-curve-workspace-header.module.scss';

interface WorkspaceHeaderLeadingProps {
  /** The workspace name, the header's title. */
  name: string;
  onBack: () => void;
  /** What follows the name: its tags and subtitle. */
  children?: ReactNode;
}

/**
 * The leading half of a dark workspace header: the Leave workspace button, then the workspace
 * name and whatever the header shows beside it. Shared by the Type Curve and Inventory workspace
 * headers, which use the same header stylesheet.
 *
 * @param {WorkspaceHeaderLeadingProps} props - Component props.
 * @return {JSX.Element} The leading block.
 */
export function WorkspaceHeaderLeading({
  name,
  onBack,
  children,
}: WorkspaceHeaderLeadingProps): JSX.Element {
  return (
    <div className={style.leading}>
      <Button
        kind="ghost"
        size="md"
        hasIconOnly
        iconDescription="Leave workspace"
        className={style.iconOnDark}
        onClick={onBack}
        renderIcon={(props) => <ArrowLeft size={20} {...props} />}
      />
      <div className={style.titles}>
        <span className={style.workspaceName}>{name}</span>
        {children}
      </div>
    </div>
  );
}
